import ru from './ru';
/* eslint-disable */
export default {
  ru,
};